import DowntimesHelpMdx from "../../help/downtimes.mdx";

export function DowntimesHelpPage() {
  return <DowntimesHelpMdx />;
}
